import React from 'react';
import { FiChevronDown, FiChevronRight } from 'react-icons/fi';

import { BtnExpander, CellExpander } from './styles';

const CustomExpander: React.FC<any> = ({
  expandableRows,
  expanderBackgroundColor,
  isRowExpandable,
  width,
  minWidth,
  onClick,
  onKeyDown,
  row,
}) => {
  return (
    <CellExpander
      style={{
        padding: 0,
        border: 'none',
      }}
    >
      <BtnExpander
        type="button"
        width={width}
        minWidth={minWidth}
        expanderBackgroundColor={expanderBackgroundColor}
        expandableRows={expandableRows}
        isRowExpandable={isRowExpandable}
        onClick={onClick}
        onKeyDown={onKeyDown}
        tabIndex={0}
      >
        {row.getIsExpanded() ? (
          <FiChevronDown strokeWidth={3} fontSize="16px" />
        ) : (
          <FiChevronRight strokeWidth={3} fontSize="16px" />
        )}
      </BtnExpander>
    </CellExpander>
  );
};

export default CustomExpander;
